/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ActivateJsonWebKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ActivateJsonWebKeyRequest = {
  /**
   * The ID of the key to activate.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ActivateJsonWebKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ActivateJsonWebKeySecurity$outboundSchema: z.ZodMiniType<
  ActivateJsonWebKeySecurity$Outbound,
  ActivateJsonWebKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function activateJsonWebKeySecurityToJSON(
  activateJsonWebKeySecurity: ActivateJsonWebKeySecurity,
): string {
  return JSON.stringify(
    ActivateJsonWebKeySecurity$outboundSchema.parse(activateJsonWebKeySecurity),
  );
}

/** @internal */
export type ActivateJsonWebKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ActivateJsonWebKeyRequest$outboundSchema: z.ZodMiniType<
  ActivateJsonWebKeyRequest$Outbound,
  ActivateJsonWebKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function activateJsonWebKeyRequestToJSON(
  activateJsonWebKeyRequest: ActivateJsonWebKeyRequest,
): string {
  return JSON.stringify(
    ActivateJsonWebKeyRequest$outboundSchema.parse(activateJsonWebKeyRequest),
  );
}
